var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-filter');
import { breakpoints } from '@shapeable/theme';
import { EntitySelectReplaceable } from './entity-select';
import { toArray } from '../../utils/to-array';
import { FilterLabel } from '../elements/filter-label';
export var EntityFilterDefaultProps = {
  onChange: function onChange() {},
  placeholder: 'Select One or More',
  borderless: true
}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SelectStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled(FilterLabel)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Select: styled(EntitySelectReplaceable)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles)
};
export var EntityFilter = function EntityFilter(props) {
  var className = props.className,
      fieldName = props.fieldName,
      label = props.label,
      onChange = props.onChange,
      select = __rest(props, ["className", "fieldName", "label", "onChange"]);

  var onSelectChange = function onSelectChange(option) {
    var options = toArray(option);
    onChange(fieldName, options);
  };

  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Label, null, label), React.createElement(My.Select, __assign({}, select, {
    onChange: onSelectChange
  })));
};
EntityFilter.defaultProps = EntityFilterDefaultProps;
EntityFilter.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;